import React from "react";
import { Helmet } from "react-helmet";

import "./App.css";
import MasterPage from "./Components/master-page";

function App() {
  return (
    <>
      <Helmet>
        <title>
          Free PDF Converter – Convert & Merge Files Instantly | WIINTE
        </title>
        <meta
          name="description"
          content="Convert and merge files to PDF instantly with WIINTE's free online PDF converter. Fast, secure, and easy to use—no installation required."
        />
        <meta
          name="keywords"
          content="Free PDF Converter, Convert PDF Online, Merge PDF, Combine PDF, Create PDF, Online PDF Tool, WIINTE PDF, PDF Converter Tool"
        />
        <meta name="author" content="WIINTE, CAO IT" />
        {/* <link rel="canonical" href="https://pdfconverter.wiinte.com" /> */}

        {/* Open Graph (Facebook, LinkedIn, etc.) */}
        <meta
          property="og:title"
          content="Free PDF Converter – Convert & Merge Files | WIINTE"
        />
        <meta
          property="og:description"
          content="Use WIINTE’s free PDF converter to merge or convert files to PDF online. No sign-up, no watermarks—just fast and easy conversion."
        />
        <meta
          property="og:image"
          content="https://pdfconverter.wiinte.com/assets/images/w.png"
        />
        <meta property="og:url" content="https://pdfconverter.wiinte.com" />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta
          name="twitter:title"
          content="Free PDF Converter – Convert & Merge PDF Online | WIINTE"
        />
        <meta
          name="twitter:description"
          content="Convert & merge PDF files quickly and for free with WIINTE. Online, secure, and user-friendly—start now!"
        />
        <meta
          name="twitter:image"
          content="https://pdfconverter.wiinte.com/assets/images/w.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <MasterPage />
    </>
  );
}

export default App;
